
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  name: "StatueHistoryComponent",

  data() {
    return {
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },

  computed: {
    majorShoppingInfos() {
      return store.state.admin.landing.majorShoppingInfos;
    },
  },

  methods: {
    // banner(image: string) {
    //     if (image !== "") {
    //         return this.url + image;
    //     } else {
    //         return "";
    //     }
    // },

    deleteMajorShoppingInfo(id: string): void {
      store.dispatch("admin/deleteMajorShoppingInfo", id);
    },
  },

  created() {
    store.dispatch("admin/getMajorShoppingInfos");
  },
});
